const TaskFormFieldset = React.memo(function TaskFormFieldset(props){
    const {
        formItem,
        items,
        label,
        display,
        value,
        index,
        buttons,
        visibilityConditions,
        showLabelAsPlaceholder,
        countryId,
        onChange,
    } = props;

    const [fieldsetCountryId, setFieldsetCountryId] = React.useState(countryId);

    React.useEffect(() => {
        if(_.get(formItem, 'ProcessFormItem.item_type') === 'address' && Boolean(_.get(formItem, 'ProcessFormItem.is_fieldset'))){
            walkItems(items, item => {
                if(_.get(item, 'ProcessFormItem.item_type') === 'address' && _.get(item, 'ProcessFormItem.person_field') === 'location_country_id'){
                    if(value[_.get(item, 'ProcessFormItem.id')]){
                        setFieldsetCountryId(value[_.get(item, 'ProcessFormItem.id')]);
                    }
                }
            });
        }
    }, [value, formItem, items]);

    React.useEffect(() => {
        setFieldsetCountryId(countryId);
    }, [countryId]);

    const change = React.useCallback(formItemId => val => {
        let newValue = _.cloneDeep(value);
        _.set(newValue, formItemId, val);
        onChange(newValue);
    }, [value, onChange]);

    const wrapperChange = React.useCallback(val => {
        let newValue = _.cloneDeep(value);
        _.each(val, (v, formItemId) => {
            newValue[formItemId] = v;
        });
        onChange(newValue);
    }, [value, onChange]);

    let children = [];
    _.each(items, (item) => {
        let render = _.get(visibilityConditions, _.get(item, 'ProcessFormItem.id'), !_.get(item, 'ProcessFormItem.is_hidden'));
        if(_.isArray(render) && !_.isNil(index)) render = render[index - 1];
        if(_.isArray(render) && _.isNil(index)) render = render[0];

        if(!render){
            return null;
        }

        let processFormItemId = _.get(item, 'ProcessFormItem.id', 'root');

        if(_.get(item, 'ProcessFormItem.item_type', '') === 'wrapper'){
            children.push(
                <TaskFormFieldset
                    key={processFormItemId}
                    formItem={item}
                    value={value}
                    items={_.get(item, 'children', [])}
                    label={_.get(item, 'ProcessFormItem.label', null)}
                    display={_.get(item, 'ProcessFormItem.display', null)}
                    onChange={wrapperChange}
                    countryId={fieldsetCountryId}
                    visibilityConditions={visibilityConditions}
                    showLabelAsPlaceholder={showLabelAsPlaceholder}
                    index={index}
                />
            );
        }else if(Boolean(_.get(item, 'ProcessFormItem.is_fieldset', false))){
            children.push(
                <TaskFormMultiFieldset
                    key={processFormItemId}
                    value={value[processFormItemId]}
                    formItem={item}
                    onChange={change(processFormItemId)}
                    visibilityConditions={visibilityConditions}
                    showLabelAsPlaceholder={showLabelAsPlaceholder}
                    itemKeys={parseItemKeys(value[processFormItemId])}
                    countryId={fieldsetCountryId}
                />
            );
        }else if(_.size(_.get(item, 'ProcessFormItem.person_field', ''))){
            children.push(
                <TaskFormField
                    key={processFormItemId}
                    value={value[processFormItemId]}
                    formItem={item}
                    onChange={change(processFormItemId)}
                    visibilityConditions={visibilityConditions}
                    indexFromParent={index}
                    parentFormItem={formItem}
                    showLabelAsPlaceholder={showLabelAsPlaceholder}
                    countryId={fieldsetCountryId}
                />
            );
        }else if(Boolean(_.get(item, 'ProcessFormItem.is_multi', false)) && _.includes(['multiselect', 'checkboxgroup'], _.get(item, 'ProcessFormItem.namespace', ''))){
            children.push(
                <TaskFormField
                    key={processFormItemId}
                    value={value[processFormItemId]}
                    formItem={item}
                    showLabelAsPlaceholder={showLabelAsPlaceholder}
                    onChange={change(processFormItemId)}
                    indexFromParent={index}
                />
            );
        }else{
            children.push(
                <TaskFormMultiField
                    key={processFormItemId}
                    value={value[processFormItemId]}
                    formItem={item}
                    onChange={change(processFormItemId)}
                    visibilityConditions={visibilityConditions}
                    showLabelAsPlaceholder={showLabelAsPlaceholder}
                    indexFromParent={index}
                    itemKeys={parseItemKeys(value[processFormItemId])}
                />
            );
        }
    });

    //useRenderDebug(`TaskFormFieldset|${_.get(formItem, 'ProcessFormItem.name', 'ROOT')}`, {props, change, wrapperChange});

    let isPlain = Boolean(!label && !_.size(buttons));
    let isMulti = Boolean(_.get(formItem, 'ProcessFormItem.is_multi', false));
    return (
        <div
            className={`react-task-form-fieldset ${isPlain ? 'plain' : ''}`}
            data-id={formItem ? `fieldset | ${isMulti ? 'multi' : 'single'} | ${formItem.ProcessFormItem.id}` : null}
        >
            {Boolean(label || _.size(buttons)) &&
                <div className={'fieldset-header'}>
                    {Boolean(label) &&
                        <div className={'title'}>
                            {label}
                            {index && <span>&nbsp;[{index}]</span>}
                        </div>
                    }
                    <div className="spacer"/>
                    {buttons}
                </div>
            }
            <div className={`fieldset-items ${display}`}>
                {children}
            </div>
        </div>
    );
});

TaskFormFieldset.propTypes = {
    formItem: PropTypes.object,
    items: PropTypes.array,
    label: PropTypes.string,
    display: PropTypes.string,
    value: PropTypes.any,
    index: PropTypes.number,
    buttons: PropTypes.array,
    visibilityConditions: PropTypes.object,
    showLabelAsPlaceholder: PropTypes.bool,
    countryId: PropTypes.number,
    onChange: value => {},
};

TaskFormFieldset.defaultProps = {
    formItem: null,
    items: [],
    label: null,
    display: null,
    value: {},
    index: null,
    buttons: null,
    visibilityConditions: {},
    showLabelAsPlaceholder: false,
    countryId: null,
    onChange: value => {},
};
TaskFormFieldset.displayName = 'TaskFormFieldset';